<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import warningTriangle from '@/assets/images/warning-triangle.svg'

const store = useStore()
const router = useRouter()

const btnLoading = ref(false)

const removeAccount = async () => {
  try {
    btnLoading.value = true
    await store.dispatch('deleteSwiftAidAccount')
    btnLoading.value = false
    router.push({ name: 'DONOR_FLOW_ManageAccountCloseConfirm' })
  } catch (error) {
    console.error(error)
    store.dispatch('setGlobalError', 'An error occurred')
    btnLoading.value = false
  }
}

onMounted(() => {
  store.dispatch('setLoading', false)
})
</script>

<template>
  <div class="sa-auth-step sa-auth-status-page" data-testid="close-account">
    <header class="sa-auth-step__header">
      <img
        :src="warningTriangle"
        class="sa-auth-status-page__swifty"
        alt=""
        aria-hidden="true"
        width="84"
        height="84"
      />
      <h1 class="sa-auth-step__title">
        {{ $t('ManageAccount.CloseAccount.Header') }}
      </h1>
      <p class="sa-auth-step__lead">
        {{ $t('ManageAccount.CloseAccount.Lead') }}
      </p>
    </header>

    <div class="sa-auth-close__actions">
      <router-link
        :to="{ name: 'Account' }"
        class="sa-btn-secondary"
        aria-label="Cancel closing account"
      >
        {{ $t('ManageAccount.CloseAccount.Cancel') }}
      </router-link>
      <button
        type="button"
        class="sa-btn-primary"
        aria-label="Confirm close account"
        :disabled="btnLoading"
        :aria-busy="btnLoading"
        @click="removeAccount"
      >
        <span
          v-if="btnLoading"
          class="spinner sa-btn-spinner"
          aria-hidden="true"
        />
        <span>
          {{
            btnLoading
              ? $t('ManageAccount.CloseAccount.Closing')
              : $t('ManageAccount.CloseAccount.Confirm')
          }}
        </span>
      </button>
    </div>
  </div>
</template>
